import { render } from "./QuestionnaireForm.vue?vue&type=template&id=833c723e"
import script from "./QuestionnaireForm.vue?vue&type=script&lang=js"
export * from "./QuestionnaireForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__